import { useContext } from "react";

import { FeatureFlagsContext } from "./feature-flags-context";

export function useSandboxCredentialsEnabled(): boolean {
  return useContext(FeatureFlagsContext).sandboxCredentialsEnabled;
}

export function useMultiPlatformDocsEnabled(): boolean {
  return useContext(FeatureFlagsContext).multiPlatformDocsEnabled;
}

/** False while LaunchDarkly still evaluates flags for the current identity. */
export function useFeatureFlagsResolved(): boolean {
  return useContext(FeatureFlagsContext).flagsResolved;
}
